import React, { useEffect, useRef, useState } from 'react';
import PageContainer from 'src/components/container/PageContainer';
import DashboardCard from 'src/components/shared/DashboardCard';
import { Button, Chip, Grid, IconButton, MenuItem, Modal, Paper, Select, Snackbar, TextField, Tooltip, Typography } from '@mui/material';
import { Box } from '@mui/system';
import { EditorState, convertToRaw } from 'draft-js';
import ShowErrorMessage, { ShowSuccess } from 'src/components/CustomComponents/ShowMessages';
import ShowLoader from 'src/components/CustomComponents/ShowLoader';
import { ReqField } from 'src/components/CustomComponents/CustomLoader';
import { AddCircleOutlineRounded, AddCircleOutlined, CloseOutlined, CloseSharp, DeleteOutline } from '@mui/icons-material';
import { useMain } from '../hooks/useMain';
import TextInputs from 'src/components/inputs/TextInputs';
import SelectInputs from 'src/components/inputs/SelectInputs';
import SuccessModal from 'src/components/Modals/SuccessModal';
import ConfirmForm from './ConfirmForm';

const initialValue = {
    clientName: "",
    clientNumber: '',
    timeOfAppointment: "",
    dateOfAppointment: "",
    sourceOfAppointment: "",
    serviceProvider: "6486a77dd7a7c82462df8149",
    serviceFor: "",
    serviceSelected: "",
    start: "",
    end: "",
    appointmentStatus: "PENDING",
    giveRewardPoints: "",
    subTotal: "",
    discount: "",
    totalAmount: "",
    paidDues: "",
    advancedGiven: "",
    branchDetails: ""
}


const AddAppointment = () => {
    const [openConfirm, setOpenConfirm] = useState(false);
    const [successModal, setSuccessModal] = useState(false);
    const [formData, setFormData] = useState(initialValue);
    const [errorMessage, setErrorMessage] = useState('');
    const [successMessage, setSuccessMessage] = useState('');
    const [showLoader, setShowLoader] = useState(false);
    const [services, setServices] = useState(null);
    const [branch, setBranch] = useState(null);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value })
    }

    const { createAppointment, fetchAllServices, fetchAllBranch } = useMain();

    const getData = async () => {
        const res = await fetchAllServices();
        setServices(res?.data);

        const res2 = await fetchAllBranch({ page: 1, limit: 50 });
        setBranch(res2?.data);
    }

    const handleSubmit = async () => {
       
        const { clientName, clientNumber, timeOfAppointment, dateOfAppointment, sourceOfAppointment, serviceFor, serviceSelected, start, end, giveRewardPoints, subTotal, discount, totalAmount, advancedGiven, branchDetails } = formData;
        if (clientName.trim() === '') return setErrorMessage('Client Name is Required');
        if (timeOfAppointment === '') return setErrorMessage('Appointement time is Required');
        if (dateOfAppointment === '') return setErrorMessage('Appointment Date is Required');
        if (clientNumber === '') return setErrorMessage('Client Number is Required');
        if (sourceOfAppointment === '') return setErrorMessage('Source is Required');
        if (serviceFor === '') return setErrorMessage('Service for is Required');
        if (serviceSelected === '') return setErrorMessage('Select a Service is Required');
        if (start === '') return setErrorMessage('Start time is Required');
        if (end === '') return setErrorMessage('End time is Required');
        if (giveRewardPoints === '') return setErrorMessage('Reward Points is Required');
        if (subTotal === '') return setErrorMessage('Price is Required');
        if (discount === '') return setErrorMessage('Discount is Required');
        if (advancedGiven === '') return setErrorMessage('Advance Given is Required');
        if (branchDetails === '') return setErrorMessage('Branch is Required');

        setShowLoader(true);

        const price = Number(subTotal);
        const dis = Number(discount);
        const total = price - (price * dis) / 100

        const res = await createAppointment(JSON.stringify({
            ...formData,
            totalAmount: total,
            paidDues: total - Number(advancedGiven),
            durationOfAppointment: { start, end }
        }));

        if (res?.statusCode === 200) {
            setSuccessMessage('Appointment Successfully Created');
            setTimeout(() => {
                setSuccessMessage('');
            }, 7000);
            // setFormData(initialValue);
            setErrorMessage('');
            setShowLoader(false);
        } else {
            setErrorMessage(res?.message);
            setTimeout(() => {
                setErrorMessage('');
            }, 7000);
            // setFormData(initialValue);
            setShowLoader(false);
        }
    };

    const handleSuccessModal = () => {
        setOpenConfirm(false);
        setSuccessModal(!successModal);
    }

    const handleCloseConfirm = () => {
        setOpenConfirm(false);
    }

    // const handleSubmit = () => {
    //     handleSuccessModal();
    // }

    useEffect(() => {
        getData();

        return () => { }
    }, [])

    return (
        <PageContainer title="Create Appointment" description="this is add Appointment">
            <DashboardCard title="Create Appointment">
                <Snackbar
                    open={errorMessage == '' ? false : true}
                    autoHideDuration={6000}
                    onClose={() => {
                        setErrorMessage('');
                    }}
                    severity="error"
                    message={errorMessage}
                    anchorOrigin={{
                        vertical: 'top',
                        horizontal: 'right',
                    }}
                />
                <Box style={{ marginTop: '20px' }}>
                    <Grid container spacing={3}>
                        <Grid item xs={12} md={4}>
                            <TextInputs
                                title={'Client Name'}
                                name={'clientName'}
                                value={formData?.clientName}
                                handleChange={handleChange}
                                type={'text'}
                            />
                        </Grid>
                        <Grid item xs={12} md={4}>
                            <TextInputs
                                title={'Source of Appointment'}
                                name={'sourceOfAppointment'}
                                value={formData?.sourceOfAppointment}
                                handleChange={handleChange}
                                type={'text'}
                            />
                        </Grid>
                        <Grid item xs={12} md={4}>
                            <TextInputs
                                title={'Discount'}
                                name={'discount'}
                                value={formData?.discount}
                                handleChange={handleChange}
                                type={'number'}
                            />
                        </Grid>
                    </Grid>
                </Box>

                <Box style={{ marginTop: '20px' }}>
                    <Grid container spacing={3}>
                        <Grid item xs={12} md={4}>
                            <TextInputs
                                title={'Contact Number'}
                                name={'clientNumber'}
                                value={formData?.clientNumber}
                                handleChange={handleChange}
                                type={'number'}
                            />
                        </Grid>
                        <Grid item xs={12} md={4}>
                            <TextInputs
                                title={'Appointment Date'}
                                name={'dateOfAppointment'}
                                value={formData?.dateOfAppointment}
                                handleChange={handleChange}
                                type={'date'}
                            />
                        </Grid>
                        <Grid item xs={12} md={4}>
                            <Box>
                                <Grid container spacing={3}>
                                    <Grid item xs={6}>
                                        <TextInputs
                                            title={'Start end Time'}
                                            name={'start'}
                                            value={formData?.start}
                                            handleChange={handleChange}
                                            type={'time'}
                                        />
                                    </Grid>
                                    <Grid item xs={6}>
                                        <TextInputs
                                            title={''}
                                            required={false}
                                            name={'end'}
                                            value={formData?.end}
                                            handleChange={handleChange}
                                            type={'time'}
                                        />
                                    </Grid>
                                </Grid>
                            </Box>
                        </Grid>
                    </Grid>
                </Box>

                <Box style={{ marginTop: '20px' }}>
                    <Grid container spacing={3}>
                        {/* <Grid item xs={12} md={4}>
                            <TextInputs
                                title={'Service Provider'}
                                // name={'productName'}
                                // value={formData?.productName}
                                // handleChange={handleChange}
                                type={'text'}
                            />
                        </Grid> */}
                        <Grid item xs={12} md={4}>
                            <SelectInputs
                                title={'Enable Rewards'}
                                options={[{ title: 'Yes', value: true }, { title: 'No', value: false }]}
                                name={'giveRewardPoints'}
                                value={formData?.giveRewardPoints}
                                handleChange={handleChange}
                                optionTitle={'title'}
                                optionValue={'value'}
                            />
                        </Grid>
                        <Grid item xs={12} md={4}>
                            <TextInputs
                                title={'Service For'}
                                name={'serviceFor'}
                                value={formData?.serviceFor}
                                handleChange={handleChange}
                                type={'text'}
                            />
                        </Grid>
                        <Grid item xs={12} md={4}>
                            <SelectInputs
                                title={'Select Service'}
                                options={services}
                                name={'serviceSelected'}
                                value={formData?.serviceSelected}
                                handleChange={handleChange}
                                optionTitle={'serviceName'}
                                optionValue={'_id'}
                            />
                        </Grid>
                    </Grid>
                </Box>

                <Box style={{ marginTop: '20px' }}>
                    <Grid container spacing={3}>
                        <Grid item xs={12} md={4}>
                            <TextInputs
                                title={'Time of Billing'}
                                name={'timeOfAppointment'}
                                value={formData?.timeOfAppointment}
                                handleChange={handleChange}
                                type={'time'}
                            />
                        </Grid>
                        <Grid item xs={12} md={4}>
                            <TextInputs
                                title={'Total Price'}
                                name={'subTotal'}
                                value={formData?.subTotal}
                                handleChange={handleChange}
                                type={'number'}
                            />
                        </Grid>
                        <Grid item xs={12} md={4}>
                            <TextInputs
                                title={'Advance Given'}
                                name={'advancedGiven'}
                                value={formData?.advancedGiven}
                                handleChange={handleChange}
                                type={'number'}
                            />
                        </Grid>
                    </Grid>
                </Box>

                <Box style={{ marginTop: '20px' }}>
                    <Grid container spacing={3}>
                        <Grid item xs={12} md={4}>
                            <SelectInputs
                                title={'Select Branch'}
                                options={branch}
                                name={'branchDetails'}
                                value={formData?.branchDetails}
                                handleChange={handleChange}
                                optionTitle={'branchName'}
                                optionValue={'_id'}
                            />
                        </Grid>
                    </Grid>
                </Box>


                {showLoader && <ShowLoader value={showLoader} />}
                {successMessage != '' && <ShowSuccess message={successMessage} />}

                <div style={{ width: '200px', margin: '3rem auto' }}>
                    <Button
                        variant="contained"
                        fullWidth
                        color="primary"
                        target="_blank"
                        sx={{
                            background: '#6174DD'
                        }}
                        // onClick={() => setOpenConfirm(true)}
                        onClick={handleSubmit}
                    >
                        Submit
                    </Button>
                </div>
            </DashboardCard>
            <Modal
                open={openConfirm}
                onClose={handleCloseConfirm}
                aria-labelledby="confirm-modal-title"
                aria-describedby="confirm-modal-description"
            >
                <ConfirmForm handleCloseConfirm={handleCloseConfirm} handleSubmit={handleSuccessModal} />
            </Modal>
            <SuccessModal open={successModal} handleClose={handleSuccessModal} text={'Congratulations on your Appoinment successfully !'} />
        </PageContainer>
    )
}

export default AddAppointment